const Founder = () => {
    return (
        <section id="founder" className="section founder-section">
            <div className="container">
                <div className="founder-card">
                    <div
                        className="founder-photo"
                        style={{
                            backgroundImage: "url('/images/foundersimg.png')"
                        }}
                    />
                    <div className="founder-body">
                        <h2>Meet the Founder</h2>
                        <h3>Abhishek Dubey — Founder</h3>
                        <p className="founder-bio">
                            Abhishek Dubey is the founder of Daycareglobal.in, a venture he originally launched in 2020 with a vision to transform the daycare and preschool industry. 
                            However, like many businesses, the journey was disrupted by the COVID-19 pandemic, which led to the closure of the startup.
                            In 2026, Abhishek revived Daycareglobal.in with a renewed vision—to reshape the daycare and preschool ecosystem by making quality childcare more accessible, reliable, and convenient for families.
                            An accomplished software engineer with around 8 years of professional experience and a graduate of Dayananda Sagar College of Engineering, Bangalore, Abhishek has always aspired to build a company that combines sustainable business growth with meaningful social impact.
                            His vision goes beyond building a successful business. He wants to create a platform that addresses a real and growing challenge faced by modern families—especially working parents and mothers who struggle to find trustworthy, high-quality childcare.
                            With Daycareglobal.in, Abhishek aims to use technology, innovation, and a customer-first approach to create a more organized, transparent, and dependable childcare ecosystem.
                        </p>
                        <blockquote className="founder-quote">“Every mother deserves the freedom to dream, grow, and pursue her aspirations while knowing her child is safe, cared for, and loved. At Daycareglobal, we’re building a world where no mother has to choose between caring for her child and chasing her dreams.”</blockquote>
                        <div className="actions">
                            {/* <button className="btn btn-primary">Book a Meeting</button> */}
                            {/* <button className="btn btn-secondary">Read Abhishek's Note</button> */}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Founder